// extracted by mini-css-extract-plugin
module.exports = {"updateProfileBtnWrapper":"styles-module__updateProfileBtnWrapper___2IOJY","updateProfileBtn":"styles-module__updateProfileBtn___2lshi"};